import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment fullDealSettings on DealSettings {
    companyBenefits {
      name
      topOfHomepage
      logoUrl
      whitelist {
        key
        value
      }
    }
  }
`

export default fragment
